import stbAPIGateway from '../../../../services/stbAPIGateway';

// eslint-disable-next-line import/prefer-default-export
export const fetchClientStudentManagement = async ({ rootGetters, commit }, clientSid) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);
  const response = await stbApi.getClientStudentManagement(clientSid);
  if (response.data) {
    commit('setClientStudentManagement', response.data);
  }
  return response;
};
